<template>
  <div class="server-container">
    <h2>服务器管理</h2>
    <div class="content">
      这里是服务器管理页面的内容
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServerManagement'
}
</script>

<style lang="scss" scoped>
.server-container {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  
  .content {
    margin-top: 20px;
  }
}
</style>